"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconGuides = void 0;

var React = __importStar(require("react"));

exports.IconGuides = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "31",
    height: "40",
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M13.3873 0.00124074C12.9224 0.0527304 12.5715 0.445121 12.5751 0.910309V3.55229H5.50722C5.47337 3.55051 5.44131 3.55051 5.40747 3.55229C5.20263 3.5736 5.01204 3.66415 4.86598 3.80796L0.263176 8.38149C-0.0877252 8.73481 -0.0877252 9.30656 0.263176 9.65986L4.86598 14.2334C5.03697 14.3985 5.26853 14.4908 5.50719 14.4891H12.5751V17.7418H4.92307C4.41897 17.7418 4.01108 18.1484 4.01108 18.6509V27.7843C4.01108 28.2868 4.41898 28.6933 4.92307 28.6933H12.5751V38.1817H8.85592C8.61189 38.1782 8.37676 38.2723 8.20221 38.4427C8.02943 38.615 7.93146 38.8476 7.93146 39.0908C7.93146 39.3341 8.02943 39.5667 8.20221 39.7389C8.37677 39.9094 8.61189 40.0035 8.85592 39.9999H13.487C13.9911 39.9999 14.399 39.5933 14.399 39.0908V28.6934H16.5934V39.0908C16.5934 39.5933 17.0013 39.9999 17.5054 39.9999H22.1365C22.3805 40.0035 22.6157 39.9094 22.7902 39.7389C22.963 39.5667 23.061 39.3341 23.061 39.0908C23.061 38.8476 22.963 38.615 22.7902 38.4427C22.6157 38.2723 22.3805 38.1782 22.1365 38.1817H18.4173V28.6933H25.4852C25.7257 28.6916 25.9573 28.5939 26.1265 28.4235L30.7293 23.864C30.902 23.6936 31 23.461 31 23.2177C31 22.9745 30.902 22.7419 30.7293 22.5714L26.1265 18.012C25.9572 17.8415 25.7257 17.7439 25.4852 17.7421H18.4173V14.4894H26.0694C26.5735 14.4894 26.9814 14.0828 26.9814 13.5803V4.46145C26.9814 3.95896 26.5735 3.55238 26.0694 3.55238H18.4173V0.9104C18.4173 0.407913 18.0094 0.00133156 17.5053 0.00133156H13.4869C13.4531 -0.000443853 13.421 -0.000443853 13.3872 0.00133156L13.3873 0.00124074ZM14.3991 1.81938H16.5936V3.55229H14.3991V1.81938ZM5.87748 5.37043H25.1574V12.6712H5.87748L2.18676 9.0207L5.87748 5.37043ZM14.3991 14.4893H16.5936V17.742H14.3991V14.4893ZM5.83508 19.5601H25.1008L28.7915 23.2248L25.1151 26.8752H5.83521L5.83508 19.5601Z",
    fill: color
  }));
});